module.exports = __webpack_public_path__ + "components/HomepageHero/2020_Hero_CommonSenseMedia.png";